import styledParser from "@libs/parser/styled-parser";

interface IStyledParser {
  value: string;
}

const StyledParser = ({ value }: IStyledParser) => <>{styledParser(value)}</>;

export default StyledParser;
